/**
 * Canonical task status values. This is the single source of truth for
 * the set of statuses — the rpc contract builds its zod enum from this
 * array, and @erp/shared-utils types the transition state machine against
 * the derived `TaskStatus` union. Add or remove a status here and both
 * sides follow.
 */
export const TASK_STATUSES = [
  "pending",
  "in_progress",
  "completed",
  "failed",
  "cancelled",
  "needs_input",
] as const;

export type TaskStatus = (typeof TASK_STATUSES)[number];
